module.exports = __webpack_public_path__ + "static/media/JumpStart.5af7eb5a.svg";